import { AbstractControl, AbstractControlOptions, AsyncValidatorFn, FormArray, FormGroup, ValidatorFn } from "@angular/forms";

export class EformArray extends FormArray {
    name: string;
    linkedIds: Array<String>;

    constructor(controls: AbstractControl[], _name?: string, _idInput?: string, validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null, asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null){
        super(controls,validatorOrOpts,asyncValidator);
        this.name = _name.replace("[]","");
        this.linkedIds = [];
        if (_idInput) {
            this.linkedIds.push(_idInput.split('_')[0])
        }
    }

    addLinkedId(_id){
        this.linkedIds.push(_id);
    }
  }
